module.exports = __webpack_public_path__ + "static/media/cleo-tablet-738x57@2x.bc2e1d1f.jpg";